import { Controller } from "@hotwired/stimulus"
import { Modal } from "bootstrap"

// Onboarding Step 4 — opens the "Lead Quality Tiers" description modal.
// Uses the styled Bootstrap modal (same pattern as onboarding-agreements),
// never a native browser dialog.
export default class extends Controller {
  static targets = ["modal"]

  open() {
    if (!this.hasModalTarget) return
    Modal.getOrCreateInstance(this.modalTarget).show()
  }
}
